/**
 * @name Header.js
 * @author 김권영
 * @since 2025. 01. 06.
 * @description
 * 헤더 기준 메뉴 구성 선택 -> Sidebar 메뉴 방식
 * ------------------------------------------------------------------------------------------------
 *
 */
import { AuthContext } from "@context";
import { useContext, useState } from "react";
import { FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = ({ activeMenu, onMenuSelect }) => {
  const [showLogout, setShowLogout] = useState(false);
  const {  logout } = useContext(AuthContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [formModalOpen, setFormModalOpen] = useState(false);

  const menus = [
    { id: "mem", title: "회원관리" },
    { id: "comp", title: "업체관리" },
    { id: "edu", title: "교육관리" },
    { id: "sup", title: "지원관리" },
    // { id: "sys", title: "시스템관리" },
  ];

  const handleLogoutShow = () => setShowLogout(true);
  const handleLogoutClose = () => setShowLogout(false);

  const handleLogout = () => {
    logout();
    handleLogoutClose();
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <>
      <header className="header">
        <nav className="topbar">
          {/* 브랜드 영역 */}
          <div className="brand">
            <Link to="/master/main" className="brand-link">
              <div className="logo">
                <img src="/img/logo2.png" alt="로고" width="100" height="60" />
              </div>
              <div className="brand-text">안전교육센터</div>
            </Link>
          </div>
          {/* 메뉴 영역 */}
          <div className="menu">
            {menus.map((menu) => {
              return (
                <div 
                  key={menu.id} 
                  className={`menu-item ${activeMenu === menu.id ? "active" : ""}`}
                  onClick={() => onMenuSelect(menu.id)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") onMenuSelect(menu.id);
                  }}
                >
                  {menu.title}
                </div>
              );
            })}
          </div>
          {/* 사용자 정보 및 드롭다운 영역 */}
          <div className="user-menu">
            <div className="dropdown" onClick={toggleDropdown}>
              <div className="dropdown-toggle">
                <FaUser className="user-icon" />
                <span className="user-text">사용자</span>
              </div>
              {dropdownOpen && (
                <div className="dropdown-menu">
                  {/* <div className="dropdown-item" onClick={() => setFormModalOpen(true)}>
                    내정보
                  </div> */}
                  <div className="dropdown-divider" />
                  <div className="dropdown-item" onClick={handleLogoutShow}>
                    로그아웃
                  </div>
                </div>
              )}
            </div>
          </div>
        </nav>
      </header>

      {/* 로그아웃 모달 */}
      {showLogout && (
        <div className="modal-overlay" onClick={handleLogoutClose}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>로그 아웃 하시겠습니까?</h3>
              <button className="modal-close" style={{padding:"0px;"}} onClick={handleLogoutClose}>×</button>
            </div>
            <div className="modal-body">
              <p>로그아웃 선택 시 현재 세션이 종료됩니다.</p>
            </div>
            <div className="modal-footer">
              <button className="btn-secondary" onClick={handleLogoutClose}>취소</button>
              <button className="btn-primary" onClick={handleLogout}>로그아웃</button>
            </div>
          </div>
        </div>
      )}

      {/* 내정보 모달 등 다른 모달도 formModalOpen 상태로 관리 가능 */}
    </>
  );
};

export default Header;

